import React, {useId} from "react";
import {ColorPickerBox, ColorPickerBox_Props} from "react-vcomponents";
import {BaseProps} from "react-vextensions";

type Props = ColorPickerBox_Props & BaseProps;

/** Wrapper around ColorPickerBox that uses CSS anchor positioning so the
 *  colour-picker popup flips to stay within the viewport instead of clipping. */
export const ColorPickerBox_Ext = (props: Props)=>{
	const {popupStyle, ...rest} = props;
	const anchorName = `--cpb-${useId().replace(/:/g, "")}`;
	return (
		<div style={{anchorName, display: "inline-block"} as React.CSSProperties}>
			<ColorPickerBox
				{...rest}
				popupStyle={{
					position: "fixed",
					positionAnchor: anchorName,
					top: "anchor(bottom)",
					left: "anchor(left)",
					zIndex: 100,
					positionTryFallbacks: "flip-block, flip-inline, flip-block flip-inline",
					...popupStyle,
				} as React.CSSProperties}
			/>
		</div>
	);
};
